/* eslint camelcase: 0 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as categoryActions from '../../../actionCreators/category';
import * as commonAction from '../../../actionCreators/common';
import { showGlobalHeaderFooter } from '../../../actionCreators/header';
import CategoryHelmet from '../../../CommonComponents/Helmet/CategoryHelmet';
import getSetCookie from '../../../cookie';
import Customevent from '../../../utils/Customevent';
import { viewItemListGA4 } from '../../../utils/gaFour';
import { triggerDataLayerOnPageView } from '../../../utils/googleAnalytics';
import { discountCalculator, getProductType, isSearchCrawler } from '../../../utils/helper';
import { extractUtmSourceFromUrl, getHelplineNo, readQueryParam } from '../../../utils/helper';
import localStorageHelper from '../../../utils/localStorageHelper';
import sessionStorageHelper from '../../../utils/sessionStorageHelper';
import BannerAndStaticHTML from '../../components/Banner/BannerAndStaticHTML';
import AboutCategory from '../../components/CategoryListing/AboutCategory';
import Listing from '../../components/CategoryListing/Listing';
import BlankWidget from '../../components/CategoryListing/Widgets/BlankWidgets';
import BackToTop from '../../components/Common/BackToTop';
import Breadcrumb from '../../components/Common/Breadcrumb';
import ExchangeHeader from '../../components/Common/ExchangeHeader';
import ActiveFilters from '../../components/Filters/ActiveFilters';
import FilterDtm from '../../components/Filters/FilterDtm';
import Filters from '../../components/Filters/Filters';
import SortFilter from '../../components/Filters/SortFilter';
import PhoneNumberCapturePopUp from '../../components/PhoneNumberCapture/PhoneNumberCapturePopUp';
import LKModal from '../../components/Modal/Modal';
import SwitchBar from '../../components/SwitchBar/SwitchBar';
import data from '../reloadData';
import './Category.scss';
import { userProperties } from '../../../CommonComponents/UserPropertiesForGA/UserProperties';

class Category extends Component {
  static propTypes = {
    redisCommonData: PropTypes.any,
    userInfo: PropTypes.object,
    section: PropTypes.string,
    categoryID: PropTypes.any,
    categoryData: PropTypes.object,
    filterData: PropTypes.object,
    FilterDataObj: PropTypes.object,
    catFilterLoaded: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.pageParam = Number(readQueryParam('page', props.location.search, true));
    this.pathname = props.location.pathname;
    this.currUrl = `${this.pathname}${props.location.search}`;
    this.state = {
      listingScrollStopIndex: 0,
      numberOfProductsNotShownDueToPageParam:
        !props.isCachedData && this.pageParam
          ? this.pageParam * props.redisCommonData.CATEGORY_PAGE_SIZE_COUNT
          : 0,
      order: 'desc',
      showPhnCapture: true,
      openYoutubeModal: false,
      bannerObj: null,
    };
    this.filterArray = [];
    this.bodyClassName = {
      backgroundColor: 'lightgray',
    };
    this.userPropertiesRunOnce = false;
    this.addingGaDataInFilterArray = this.addingGaDataInFilterArray.bind(this);
    this.updateTryOnSwitch = this.updateTryOnSwitch.bind(this);
    this.openYoutubePopUp = this.openYoutubePopUp.bind(this);
    this.handlePhnCaptureDesktop = this.handlePhnCaptureDesktop.bind(this);
    this.isExchange =
      (sessionStorageHelper.getItem('exchangeMethod') === 'NEWPRODUCT' &&
        sessionStorageHelper.getItem('exchangeNP') === true) ||
      null;
  }
  componentDidMount() {
    if (this.isExchange) {
      this.props.showGlobalHeaderFooter({ header: false });
    }
    const {
      categoryActions,
      categoryData,
      categoryID,
      commonAction,
      FilterDataObj,
      isCachedData,
      localeInfo,
      location,
      login,
      pageCounter,
      redisCommonData,
      userInfo,
    } = this.props;
    const dittoConfig = redisCommonData.DITTO_CONFIG && JSON.parse(redisCommonData.DITTO_CONFIG);
    if (!isCachedData) window.scrollTo(0, 0);
    document.getElementsByTagName('body')[0].classList.add('cat');
    if (
      redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG &&
      JSON.parse(redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG).category === 'ON' &&
      this.pathname?.indexOf('/search') < 0
    ) {
      this.changeLenskartLogo(this.props);
    }

    if (this.pathname?.indexOf('/search') > -1) {
      commonAction.changeLogo('lenskart');
      if (window.location.hash) {
        // const isSort = window.location.hash.split('&').some(filter => filter.includes('dir=') || filter.includes('gan_data=') || filter.includes('sort='));
        categoryActions.loadCatAndFilterData(
          null,
          data.reloadData(window.location.hash.replace('#', ''), categoryActions, location)
        );
      } else {
        categoryActions.getSearchFilterData({ location, params: '', pageCounter });
      }
    }

    if (!categoryID && !location.search) {
      const path = this.pathname.slice(1).replace(/(\/+)$/g, '');
      const params = location.hash ? location.hash : null;
      commonAction.getRedisRouter({ path, params, location });
    }
    if (categoryID && categoryData.result) {
      // dataLayer update
      const {
        utm_source = null,
        utm_medium = null,
        utm_campaign = null,
        utm_term = null,
        utm_content = null,
      } = extractUtmSourceFromUrl(this.props.location.search);
      if (utm_source) {
        localStorage.setItem(
          'utmSource',
          JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
        );
      } else if (!localStorage.getItem('utmSource')) {
        localStorage.setItem(
          'utmSource',
          JSON.stringify({ utm_source, utm_medium, utm_campaign, utm_term, utm_content })
        );
      }
      const utmSource = JSON.parse(localStorage.getItem('utmSource'));
      let dataLayerData = {};
      dataLayerData = {
        event: 'VirtualPageView',
        PageUrl: window.location.href,
        visitorStore: window.location.host,
        visitorUtm_Source: utmSource.utm_source || '(direct)',
        visitorUtm_Cam: utmSource.utm_campaign || '(direct)',
        visitorUtm_Medium: utm_medium || '(none)',
        isLoggedIn: login ? 1 : 0,
        visitorCategoryId: categoryID,
        visitorCategoryName: categoryData.result.category_name,
        EmailId: userInfo !== null ? userInfo?.result?.email : '',
        mobile:
          userInfo !== null &&
          userInfo?.result?.telephone !== undefined &&
          typeof window !== 'undefined' &&
          typeof window.btoa !== 'undefined'
            ? window.btoa(userInfo?.result?.telephone)
            : '',
        visitorPageType: 'CategoryPage',
        // repeat for check if all goes ok then we have to remove repeated one
        utmSource: utmSource?.utm_source || '',
        utmCampaign: utmSource?.utm_campaign || '',
        utmMedium: utmSource?.utm_medium || '',
        utmTerm: utmSource?.utm_term || '',
        utmContent: utmSource?.utm_content || '',
        website_source: `${localeInfo?.countryCode} headless`,
      };
      window?.dataLayer?.push(dataLayerData);
      if (typeof window?.clevertap !== 'undefined') {
        window?.clevertap.event.push('Page Visited', {
          pageName: 'product Listing page',
        });
        window.clevertap.event.push('Category Page', {
          pageName: 'product List page',
          category_ID: categoryID,
          category_Name: categoryData.result.category_name,
          category_Type: categoryData.result.categoryType,
        });
      }
      if (utm_source?.toLowerCase() === 'hotstar_blu_17sep') {
        if (typeof window?.clevertap !== 'undefined') {
          window?.clevertap?.event?.push('Utm Event', {
            Utm_Source: utm_source,
            Utm_Medium: utm_medium,
            Utm_Campaign: utm_campaign,
            Ad: 'ipl_kkr_match47',
          });
        }
      }
      let count = 1;
      const topPids =
        categoryData?.result?.product_list &&
        categoryData?.result?.product_list?.map(item => {
          let prodType = '';
          if (item.sku && item.sku?.indexOf('eye:') > -1) prodType = 'Eyeglasses';
          else if (item.sku && item.sku?.indexOf('sun:') > -1) prodType = 'Sunglasses';
          else if (item.sku && item.sku?.indexOf('contact:') > -1) prodType = 'Contact Lens';
          else if (item.sku && item.sku?.indexOf('watch:') > -1) prodType = 'Accessories';
          else prodType = 'Others';
          return {
            id: item.id,
            price: item.prices[1].price,
            brand: item.brand_name,
            category: prodType,
            variant: '',
            list: '',
            dimension21: categoryID,
            position: count++,
          };
        });
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.Listing.load.ecommTop15Products(
          login ? 'loggedIn' : 'guest',
          topPids
        );
        window.dtm.LenskartRewamp.Listing.load.verticalFilter('vertical');
      }
      if (categoryData && categoryData.result && categoryData.result?.product_list?.length >= 1) {
        viewItemListGA4(categoryData, login);
      }
    }
    if (window.location.hash && categoryID) {
      categoryActions.loadCatAndFilterData(
        categoryID,
        data.reloadData(window.location.hash.replace('#', ''), categoryActions, location)
      );
    } else if (categoryID && categoryData.result) {
      categoryActions.getFilterData(categoryID);
    }

    if (
      dittoConfig &&
      dittoConfig.isCatDittoView === 'ON' &&
      getSetCookie.getCookie('isDittoID') !== '' &&
      (getSetCookie.getCookie('showMeDitto') === '' ||
        getSetCookie.getCookie('showMeDitto') === 'true')
    ) {
      getSetCookie.setCookie('showMeDitto', true);
    } else {
      getSetCookie.setCookie('showMeDitto', false);
    }
    if (
      location.hash === '' &&
      Object.keys(FilterDataObj).length === 0 &&
      categoryData &&
      categoryData.result &&
      !location.search
    ) {
      const dtmObject = {
        obj: {},
        sort: '',
        filter: '',
        login,
        userInfo,
      };
      FilterDtm.updateCategoryDtm(categoryData.result, dtmObject);
    }
    const event = new Customevent('categoryDataLoaded');
    event.dispatch();
    if (getSetCookie.getCookie('isDittoID') && getSetCookie.getCookie('showMeDitto') !== 'false') {
      this.updateTryOnSwitch(true);
      categoryActions.updateDittoEnable(true);
    } else {
      this.updateTryOnSwitch(false);
      categoryActions.updateDittoEnable(false);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      catFilterLoaded,
      section,
      filterData,
      reload,
      categoryActions,
      location,
      categoryData,
      prevUrl,
      userInfo,
      login,
      order,
      pageCounter,
    } = this.props;
    if (
      userInfo?.result &&
      Object.keys(userInfo?.result).length > 0 &&
      !this.userPropertiesRunOnce
    ) {
      userProperties(this.props.userInfo?.result, 'plp-page', 'desktop', this.props.dataLocale);
      this.userPropertiesRunOnce = true;
    }
    if (
      prevProps.categoryData.result &&
      categoryData.result &&
      prevProps.categoryData.result.categoryId + '' !== categoryData.result.categoryId + ''
    ) {
      FilterDtm.updateCategoryDtm(categoryData.result, {
        userInfo,
        login,
        sort: order,
        filter: '',
      });
      if (window.location.hash && categoryData.result.categoryId) {
        categoryActions.loadCatAndFilterData(
          categoryData.result.categoryId,
          data.reloadData(window.location.hash.replace('#', ''), categoryActions, location)
        );
      } else if (categoryData.result.categoryId) {
        categoryActions.getFilterData(categoryData.result.categoryId);
      }
    }
    // this case to handle the search, when prev url is search and current data is fetched from cache
    if (prevUrl === '/search' && categoryData.result) {
      if (window.location.hash && categoryData.result.categoryId) {
        // const isSort = window.location.hash.split('&').some(filter => filter.includes('dir=') || filter.includes('gan_data=') || filter.includes('sort='));
        categoryActions.loadCatAndFilterData(
          categoryData.result.categoryId,
          data.reloadData(window.location.hash.replace('#', ''), categoryActions, location)
        );
      } else if (categoryData.result.categoryId && !catFilterLoaded) {
        // PK: catFilterLoaded introduced to stop multiple call of filter when coming from search page
        categoryActions.getFilterData(categoryData.result.categoryId);
      }
    }

    if (
      section === 'cat' &&
      filterData &&
      typeof filterData.result !== 'undefined' &&
      reload.reload
    ) {
      /* To make FilterDataObj to check Checkbox and filter text. */
      const FilterDataObj = {};
      Object.keys(reload.data).forEach(key => {
        FilterDataObj[key] = [];
        reload.data[key].forEach(keyValue => {
          filterData.result.filters.forEach(data => {
            data.options.forEach(furtherData => {
              if (furtherData.id === keyValue) {
                const obj = {};
                obj.childid = furtherData.id;
                obj.childname = furtherData.title;
                FilterDataObj[key].push(obj);
              }
            });
          });
        });
      });
      Object.keys(reload.data).forEach(key => {
        FilterDataObj[key].forEach(keyValue => {
          const filter = {};
          filter[key] = keyValue.childname;
          this.filterArray.push(filter);
        });
      });
      const temp = {};
      temp.FilterDataObj = FilterDataObj;
      temp.reload = {};
      temp.reload.data = reload.data;
      temp.reload.reload = false;
      categoryActions.modifyData(temp);
      if (
        window.location.hash &&
        Object.keys(FilterDataObj).length > 0 &&
        categoryData.result &&
        categoryData.result.categoryId &&
        categoryData.params &&
        categoryData.params.replace(/filter_/g, '') !== window.location.hash.replace('#', '')
      ) {
        categoryActions.getCategoryData(
          categoryData.result.categoryId,
          data.reloadData(window.location.hash.replace('#', ''), categoryActions, location),
          pageCounter
        );
      }
    }
  }

  componentWillUnmount() {
    if (this.props.isFilterEnable) {
      this.props.categoryActions.unsetFilterState();
    }
    document.getElementsByTagName('body')[0].classList.remove('cat');
  }

  listingScrollStop(index) {
    this.setState({
      listingScrollStopIndex: index,
    });
  }

  addingGaDataInFilterArray(isContainFilterData, filter, currentFilterData, childname) {
    if (isContainFilterData) {
      this.filterArray = this.filterArray.filter(x => x[currentFilterData?.id] !== childname);
    } else {
      this.filterArray.push(filter);
    }
  }

  dittoSwitchBar = () => {
    const { categoryData, dittoEnable, categoryActions, localeInfo } = this.props;
    const pageInfo = `page:${this.pathname}`;
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.ditto.click.listing.triggerDTM(categoryData.result.categoryType);
    if (getSetCookie.getCookie('isDittoID')) {
      if (getSetCookie.getCookie('showMeDitto') === 'false' && dittoEnable === false) {
        getSetCookie.setCookie('showMeDitto', true);
      } else {
        getSetCookie.setCookie('showMeDitto', false);
      }
      if (dittoEnable || getSetCookie.getCookie('showMeDitto') === 'false') {
        categoryActions.updateDittoEnable(false);
        this.updateTryOnSwitch(false);
        if (localeInfo.countryCode !== 'sg') {
          _gaq.push(
            ['_trackEvent', 'Ditto', 'DittoNWF_Filters', 'button:view-frame'],
            ['ninja._trackEvent', 'Ditto', 'DittoNWF_Filters', 'button:view-frame']
          );
        }
      } else {
        categoryActions.updateDittoEnable(true);
        this.updateTryOnSwitch(true);
        if (localeInfo.countryCode !== 'sg') {
          _gaq.push(
            ['_trackEvent', 'Ditto', 'DittoNWF_Filters', 'button:view-ditto'],
            ['ninja._trackEvent', 'Ditto', 'DittoNWF_Filters', 'button:view-ditto']
          );
        }
      }
    } else {
      localStorage.setItem('dittoCompare', window.location.href);
      window.location = '/compare-looks';
      if (localeInfo.countryCode !== 'sg') {
        _gaq.push(
          ['_trackEvent', 'Ditto', 'DittoNWF_GetStarted_CategoryPage', pageInfo],
          ['ninja._trackEvent', 'Ditto', 'DittoNWF_GetStarted_CategoryPage', pageInfo]
        );
      }
    }
  };

  changeLenskartLogo(props) {
    const { categoryData, commonAction } = props;
    if (
      categoryData.result &&
      categoryData.result.categoryType &&
      !(categoryData.result.categoryType.toLowerCase()?.indexOf('eyeglass') > -1)
    ) {
      commonAction.changeLogo('dealskart');
    } else {
      commonAction.changeLogo('lenskart');
    }
  }
  updateTryOnSwitch(flag) {
    this.props.commonAction.updateTryOnSwitch({ isTryOnSwitch: flag });
    if (flag && window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.Pdp.load.tryOnSwitchOnLoad();
    }
  }

  handlePhnCaptureDesktop = () => {
    localStorageHelper.setItem('repeatFlowPhoneCapture', 'true');
    this.setState({
      showPhnCapture: !this.state.showPhnCapture,
    });
  };

  openYoutubePopUp(bannerObj) {
    this.setState({ openYoutubeModal: true, bannerObj });
  }

  close = () => {
    this.setState({ openYoutubeModal: false });
  };

  render() {
    const {
      breadcrumb,
      categoryActions,
      categoryData,
      categoryID,
      categoryScrollTo,
      categoryType,
      catImgLink,
      counter,
      dataLocale,
      dittoEnable,
      filterData,
      FilterDataObj,
      filterDrop,
      filterFail,
      history,
      isCachedData,
      localeInfo,
      location,
      order,
      powerUrls,
      redisCommonData,
      section,
      setWishList,
      totalProductCount,
      userInfo,
      isExchange,
    } = this.props;
    if (!categoryData) {
      console.error(`${new Date()} : ${this.pathname} : Category Data Not Found.`);
    }
    const phoneCaptureConfig =
      redisCommonData &&
      redisCommonData?.PHONE_NUMBER_CAPTURE_CONFIG_NEW_DESKTOP &&
      JSON.parse(redisCommonData?.PHONE_NUMBER_CAPTURE_CONFIG_NEW_DESKTOP);
    const repeatFlowPhoneCapture = localStorageHelper.getItem('repeatFlowPhoneCapture');
    const categoryName = categoryData.result ? categoryData.result.category_name : '';
    const powerUrlsWidth =
      categoryData.result &&
      categoryData.result.category_power_urls &&
      categoryData.result.category_power_urls.length
        ? 100 / `${categoryData.result.category_power_urls.length}%`
        : '100%';
    const helplineNo = redisCommonData
      ? getHelplineNo(redisCommonData.MISSED_CALL_CONFIG, categoryType)
      : '';
    const { CATEGORY_PAGE_SIZE_COUNT } = redisCommonData;
    const { EYEGLASSES, VIEW, SUNGLASSES, NO_RESULT_FOUND } = dataLocale;
    return (
      <React.Fragment>
        {categoryData.result && (
          <CategoryHelmet
            LISTING_PAGE_SIZE={CATEGORY_PAGE_SIZE_COUNT}
            categoryData={categoryData.result}
            currUrl={`${localeInfo.domain}${this.currUrl}`}
            localeInfo={localeInfo}
            location={location}
            pageParam={this.pageParam}
            pathname={this.pathname}
          ></CategoryHelmet>
        )}
        {this.isExchange && (
          <ExchangeHeader
            history={history}
            subtitle="Choose from variety of frame shapes shown below"
            title="Select Frame"
          />
        )}
        <div
          className={`main-content-wrapper vertical-filter category${
            filterData &&
            filterData.result &&
            filterData.result.filters &&
            filterData.result.filters.length === 0
              ? ' zero-filters'
              : ''
          }`}
          id="categoryPage"
        >
          {/* Below hidden ditto element is added to fix the console issue related to ditto api image offset */}
          <div className="hideElement" id="ditto" />
          {<BackToTop key="back-to-top" isImageExist={catImgLink} />}
          {breadcrumb && breadcrumb.length > 0 && (
            <Breadcrumb
              breadcrumbData={breadcrumb}
              dataLocale={dataLocale}
              helplineNo={helplineNo}
            />
          )}

          {catImgLink && (
            <BannerAndStaticHTML
              bannerData={[{ src: catImgLink, title: 'offer banner' }]}
              style={{ marginBottom: '0px', overflow: 'hidden', clear: 'both' }}
            />
          )}

          <div className="plp-middle-container">
            <div className="plp-filters-container" id="plp-filters-container">
              {!filterData && !filterFail && (
                <div className="filters-navigate default-filters">
                  <BlankWidget styleObj="filter-loader" />
                </div>
              )}
              <div
                className={
                  filterData &&
                  filterData.result &&
                  filterData.result.filters &&
                  filterData.result.filters.length > 0
                    ? 'filters-navigate default-filters'
                    : ''
                }
              >
                {filterData && [
                  <Filters
                    key="filter"
                    FilterDataObj={FilterDataObj}
                    addingGaDataInFilterArray={this.addingGaDataInFilterArray}
                    breadcrumb={breadcrumb}
                    categoryActions={categoryActions}
                    categoryId={categoryID}
                    categoryType={categoryType}
                    dataLocale={dataLocale}
                    filterArray={this.filterArray}
                    filterData={filterData}
                    filterDrop={filterDrop}
                    location={location}
                    order={order}
                    redisCommonData={redisCommonData}
                    section={section}
                    userInfo={userInfo}
                  />,
                  <div key="clear-fix" className="clear-fix"></div>,
                ]}
              </div>
            </div>
            {/* } */}

            <div className="plp-main-container">
              {/* Switch bar section, category top bar */}
              {
                <div className={`switchbar-section no-padding ${filterFail ? 'full-width' : ''}`}>
                  <div
                    className="switchbar col-sm-12"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div className="col-sm-5 text-ellipsis">
                      <h1 className="text-left no-padding">{categoryName}</h1>
                      {this.pathname.includes('ditto/eyeglasses.html') ||
                      this.pathname.includes('ditto/sunglasses.html') ? (
                        <span> | </span>
                      ) : (
                        ''
                      )}
                      {this.pathname.includes('ditto/eyeglasses.html') && (
                        <Link
                          alt="Ditto Sunglasses"
                          className="dittosunglass"
                          title="Ditto Sunglasses"
                          to="/ditto/sunglasses.html"
                        >
                          {VIEW} {SUNGLASSES}
                        </Link>
                      )}
                      {this.pathname.includes('ditto/sunglasses.html') && (
                        <Link
                          alt="Ditto Eyeglasses"
                          className="dittosunglass"
                          title="Ditto Eyeglasses"
                          to="/ditto/eyeglasses.html"
                        >
                          {VIEW} {EYEGLASSES}
                        </Link>
                      )}
                    </div>

                    <SwitchBar
                      categoryName={categoryName}
                      categoryType={categoryType}
                      dataLocale={dataLocale}
                      dittoEnable={dittoEnable}
                      dittoFunc={this.dittoSwitchBar}
                      redisCommonData={redisCommonData}
                    />

                    <SortFilter
                      key="filter"
                      FilterDataObj={FilterDataObj}
                      breadcrumb={breadcrumb}
                      categoryActions={categoryActions}
                      categoryId={categoryID}
                      categoryType={categoryType}
                      dataLocale={dataLocale}
                      filterData={filterData}
                      filterDrop={filterDrop}
                      location={location}
                      order={this.state.order}
                      redisCommonData={redisCommonData}
                      section={section}
                      sortFilterValue={order}
                      userInfo={userInfo}
                    />
                  </div>
                </div>
              }

              {categoryData.result && (
                <ActiveFilters
                  {...this.props}
                  categoryId={categoryID}
                  initialIndex={this.state.numberOfProductsNotShownDueToPageParam}
                  listingScrollStopIndex={this.state.listingScrollStopIndex}
                  powerUrls={{ powerUrls }}
                />
              )}

              <div className="clear-fix"></div>

              {/* Category Power url header */}
              {categoryData.result &&
              categoryData.result.product_list.length &&
              categoryData.result.category_power_urls &&
              categoryData.result.category_power_urls.length > 0 ? (
                <ul className="power-urls">
                  {categoryData.result.category_power_urls.map((data, key) => {
                    return (
                      <li key={key} style={{ width: powerUrlsWidth || '' }}>
                        {data.value?.indexOf('www.lenskart.com') === -1 ? (
                          <Link to={data.value}>{data.key}</Link>
                        ) : (
                          <a href={data.value}>{data.key}</a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              ) : (
                ''
              )}
              {!categoryData.result &&
                categoryData.code !== 17 &&
                filterData &&
                !filterData.error && (
                  <BlankWidget
                    styleObj={
                      filterData &&
                      filterData.result &&
                      filterData.result.filters &&
                      filterData.result.filters.length < 0
                        ? 'category-loader full-width'
                        : 'category-loader'
                    }
                  />
                )}
              {!categoryData.result && filterData && filterData.error && (
                <p
                  key="no-prod"
                  className="no-result-found margin-b20 fs20 padding-t70 text-capitalize"
                >
                  {localeInfo?.countryCode === 'sg' ? NO_RESULT_FOUND : `${NO_RESULT_FOUND}!!!`}
                </p>
              )}
              {categoryData.result && [
                <Listing
                  key="listing"
                  FilterDataObj={FilterDataObj}
                  categoryActions={categoryActions}
                  categoryData={categoryData.result}
                  categoryId={categoryID}
                  categoryScrollTo={categoryScrollTo}
                  counter={counter}
                  currUrl={this.currUrl}
                  dataLocale={dataLocale}
                  dittoEnable={dittoEnable}
                  filterFail={filterFail}
                  history={history}
                  isCachedData={isCachedData}
                  isExchange={this.isExchange}
                  listingScrollStop={this.listingScrollStop.bind(this)}
                  localeInfo={localeInfo}
                  location={location}
                  login={this.props.login}
                  openYoutubePopUp={this.openYoutubePopUp}
                  pageParam={this.pageParam}
                  redisCommonData={redisCommonData}
                  setWishList={setWishList}
                  toggleTryOn={this.dittoSwitchBar}
                  totalProductCount={totalProductCount}
                />,
                !categoryData.result.product_list.length && (
                  <p key="no-prod" className="no-result-found margin-b20 fs20 text-capitalize">
                    {localeInfo?.countryCode === 'sg' ? NO_RESULT_FOUND : `${NO_RESULT_FOUND}!!!`}
                  </p>
                ),
                <div key="clear-fix" className="clear-fix"></div>,
                <AboutCategory
                  key="about-category"
                  categoryData={categoryData}
                  filterFail={filterFail}
                />,
                // <BackToTop key="back-to-top" />
              ]}
              {!isExchange &&
                phoneCaptureConfig?.category?.isShow &&
                !isSearchCrawler() &&
                repeatFlowPhoneCapture !== 'true' && (
                  <PhoneNumberCapturePopUp
                    handleClose={() => this.handlePhnCaptureDesktop()}
                    page="category"
                    showPhnCapture={this.state.showPhnCapture}
                  ></PhoneNumberCapturePopUp>
                )}
              {categoryData.code === 17 && (
                <p
                  key="no-prod"
                  className="no-result-found margin-b20 fs20 padding-t70 text-capitalize"
                >
                  {localeInfo?.countryCode === 'sg' ? NO_RESULT_FOUND : `${NO_RESULT_FOUND}!!!`}
                </p>
              )}
            </div>
          </div>
        </div>
        {this.state.openYoutubeModal && (
          <LKModal
            backdrop
            keyboard
            hideHandler={this.close}
            showModal={this.state.openYoutubeModal}
            size="large"
          >
            <div className="youtube-video-modal">
              <div
                className="youtube-cross"
                style={{ right: '-2px', top: '0px' }}
                onClick={() => this.close()}
              >
                <img alt="youtube-icon" className="youtube-icon" src="/assets/svg/Cross.svg" />
              </div>
              <div style={{ marginTop: '10px' }}>
                <iframe
                  allow="autoplay; fullscreen;"
                  height="400"
                  src={`${this.state.bannerObj?.video_url}?autoplay=${
                    this.state.bannerObj?.video_props?.isAutoplay ? 1 : 0
                  }&mute=${this.state.bannerObj?.video_props?.isMute ? 1 : 0}`}
                  style={{ width: '-webkit-fill-available' }}
                ></iframe>
              </div>
            </div>
          </LKModal>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  breadcrumb: state.category.breadcrumb,
  categoryData: state.category.categoryData,
  categoryScrollTo: state.category.categoryScrollTo,
  categoryType: state.category.categoryType,
  catFilterLoaded: state.category.catFilterLoaded,
  catImgLink: state.category.catImgLink,
  counter: state.category.counter,
  dataLocale: state.locale,
  dittoEnable: state.category.dittoEnable,
  filterData: state.category.filterData,
  FilterDataObj: state.category.FilterDataObj,
  filterDrop: state.category.filterDrop,
  filterFail: state.category.filterFail,
  handleFilterFunction: state.category.handleFilterFunction,
  isCachedData: state.category.isCachedData,
  isFilterEnable: state.category.isFilterEnable,
  localeInfo: state.common.localeInfo,
  location: state.router.location,
  login: state.common.login,
  order: state.category.order,
  powerUrls: state.category.powerUrls,
  prevUrl: state.category.prevUrl,
  productID: state.common.productID,
  redisCommonData: state.common.redisCommonData,
  reload: state.category.reload,
  section: state.common.section,
  totalProductCount: state.category.totalCountProd,
  userInfo: state.common.userInfo,
  isExchange: state?.returnExchange?.isExchange,
});
function mapDispatchToProps(dispatch) {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
    commonAction: bindActionCreators(commonAction, dispatch),
    showGlobalHeaderFooter: bindActionCreators(showGlobalHeaderFooter, dispatch),
  };
}
Category.defaultProps = {
  categoryData: {},
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Category));
